export default __webpack_public_path__ + "img/ebc48b28a11f6080d00ef1b932e44797.png";